import {Component, Inject} from '@angular/core';
import {L10N_LOCALE, L10nLocale, L10nTranslatePipe, L10nTranslationService} from 'angular-l10n';

@Component({
    selector: 'cp-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    imports: [
        L10nTranslatePipe
    ],
    standalone: true
})
export class NotFoundComponent {

    constructor(
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        public translate: L10nTranslationService,
    ) {
    }
}
